import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Input,
  Label,
} from 'reactstrap';
import { Delete } from '@mui/icons-material';
import { db } from '../../MY_LOGIN_AND_SIGNUP/db/config';
import { useLocation, useNavigate } from 'react-router-dom';
import FunctionsIcon from '@mui/icons-material/Functions';
import EditQuestionMathModal from './EditQuestionMathModal';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { InlineMath } from 'react-katex';
const EditQuestionPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  
  const { fetchSubject, questionDataToEdit } = location.state || {};
  const [IsOpenEditMathExpKeyBoard, setIsOpenEditMathExpKeyBoard] = useState(false);
  const [mathExpEdit, setMathExpEdit] = useState({});
  
  const [questionData, setQuestionData] = useState({
    questionLanguages: [],
    primaryLanguage: 'english',
    subject: '',
    topic: '',
    difficulty: 1,
    status: 0,
    questionNumber: 0,
  });

  const [topics, setTopics] = useState([]);

  useEffect(() => {
    if (questionDataToEdit) {
      db.collection('QuestionsV2')
        .where('id', '==', questionDataToEdit.id)
        .where('status', '==', 0)
        .get()
        .then((querySnapshot) => {
          if (!querySnapshot.empty) {
            const fetchedData = querySnapshot.docs[0].data();
            console.log("adding", fetchedData);
            setQuestionData(fetchedData);

            // Update topics when the subject is set
            const selectedSubject = fetchSubject.find(
              (subject) => subject.name === fetchedData.subject
            );
            setTopics(selectedSubject?.topics || []);
          } else {
            console.log('No matching question found in the database.');
          }
        })
        .catch((error) => {
          console.error('Error fetching question data:', error);
        });
    }
  }, [questionDataToEdit, fetchSubject]);

    const handleEditQuestion = async (updatedQuestion) => {
      try {
    
        console.log(updatedQuestion, 'updatedQuestion');
        updatedQuestion.primaryQuestion = updatedQuestion[
          updatedQuestion?.primaryLanguage
        ]?.question
          ?.toLowerCase()
          .trim();
          console.log('finalUpdate',updatedQuestion);
        updatedQuestion.topic = updatedQuestion?.topic;
        updatedQuestion.questionLanguages =
          updatedQuestion?.questionLanguages?.map((lang) => {
            return lang?.trim();
          });
  
        // Reference the specific document in the QuestionsV2 collection using the question's ID
        const questionRef = db.collection('QuestionsV2').doc(updatedQuestion.id);
        console.log(questionRef);
        // Update the document in the Firestore database
        await questionRef.update({
          ...updatedQuestion,
          updatedAt: new Date(),
        });
        console.log('Question updated successfully in the database');
        navigate(-1)
      } catch (error) {
        console.error('Error updating question:', error);
      } 
    };

  const handleInputChange = (e, language = null, field = null) => {
    const { name, value } = e.target;

    setQuestionData((prevState) => {
      const updatedData = { ...prevState };
      console.log(updatedData,"updatedData");
      
      if (language && field) {
        // For nested language-specific fields like options, question, correctOption
        updatedData[language] = {
          ...updatedData[language],
          [field]: value,
        };
        console.log('final', updatedData);
      } else {
        // For non-language-specific fields
        updatedData[name] = value;

        // Update topics if the subject changes
        if (name === 'subject') {
          const selectedSubject = fetchSubject.find(
            (subject) => subject.name === value
          );
          setTopics(selectedSubject?.topics || []);
        }
      }
      return updatedData;
    });
  };

  const handleArrayChange = (e, language, field, index) => {
    const { value } = e.target;
console.log(value,'isArrayChange');
    setQuestionData((prevState) => {
      const updatedData = { ...prevState };
      updatedData[language][field][index] = value;
      console.log(updatedData, 'isArrayChange2');

      return updatedData;
    });
  };

  const addNewField = (language, field) => {
    setQuestionData((prevState) => {
      const updatedData = { ...prevState };
      updatedData[language][field] = [
        ...(updatedData[language][field] || []),
        '',
      ];
      return updatedData;
    });
  };

  const removeField = (language, field, index) => {
    setQuestionData((prevState) => {
      const updatedData = { ...prevState };
      updatedData[language][field] = updatedData[language][field].filter(
        (_, i) => i !== index
      );
      return updatedData;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(questionData, 'questionData');
    handleEditQuestion({
      ...questionData,
      updatedAt: new Date().toISOString(),
    });
  };

  const modalHeaderStyle = {
    backgroundColor: 'rgb(39, 41, 61)',
    padding: '10px 15px',
    color: '#fff',
    fontSize: '18px',
    fontWeight: 'bold',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  };



  const modalBodyStyle = {
    backgroundColor: 'rgb(39, 41, 61)',
padding:'24px'
  };

  const inputStyle = {
    backgroundColor: '#2c2f47',
    color: '#fff',
    border: '1px solid #5a5e75',
    width: '-webkit-fill-available',
    height: 'auto',
    borderRadius: '5px',
    padding:'4px',
    minHeight:'30px'
  };
  const renderMixedContent = (latexInput) => {
    let inputStr = typeof latexInput == "string" ? latexInput : (String(latexInput));
    let parts = inputStr.split(/(\$[^$]+\$)/g);
    return parts.map((part, index) => {
      if (part.startsWith("$") && part.endsWith("$")) {
        let modifiedPart = part.replace(/\$/g, "");
        return <InlineMath key={index} math={modifiedPart} />;
      }
      return <span dangerouslySetInnerHTML={{__html: part}} key={index}></span>;
    });
  };


  console.log('language737', questionData?.primaryLanguage);

  return (
    <div className='content'>
      <div style={modalHeaderStyle}>
        <div>

        <button
          onClick={() => navigate('/admin/quiz')}
          style={{
            marginRight: '4px',
            color: 'white',
            border: '0',
            padding: '0 ',
            outline: 'none',
            background: 'transparent',
            cursor: 'pointer',
            marginBottom: '15px'
          }}
          >
          <KeyboardBackspaceIcon style={{ fontSize: '35px', marginRight: '12px' }} />
        </button>
        Edit Question
          </div>
      </div>

      <div style={modalBodyStyle}>
        <form onSubmit={handleSubmit}>
          {/* Place Subject and Topic Dropdowns at the top */}
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '20px',
            }}
          >
            {/* Subject Dropdown */}
            <FormGroup style={{ gap: '10px' }}>
              <Label style={{ color: '#fff', width: '100px' }}>Subject</Label>
              <Input
                type='select'
                name='subject'
                value={questionData.subject}
                onChange={handleInputChange}
                disabled
                required
                style={{
                  ...inputStyle,
                  flex: 1,
                  cursor:'no-drop',
                  borderRadius: '5px',
                  width: '100%',
                  height: '40px', // Ensures consistent dropdown height
                }}
              >
                <option value='' disabled>
                  Select a subject*
                </option>
            
                <option key={questionData.subject} value={questionData.subject}>
                  {questionData.subject}
                  </option>
             
              </Input>
            </FormGroup>

            <FormGroup style={{ gap: '10px' }}>
              <Label style={{ color: '#fff', width: '100px' }}>Topic*</Label>
              <Input
                type='select'
                name='topic'
                value={questionData.topic}
                onChange={handleInputChange}
                required
                style={{
                  ...inputStyle,
                  flex: 1,
                  width: '100%',
                  borderRadius: '5px',
                  height: '40px', // Ensures consistent dropdown height
                }}
                disabled={!topics.length}
                className={questionData.primaryLanguage == 'fganh' || questionData.primaryLanguage == 'हिंदी' ? 'hinditext':''}
              >
                <option value='' disabled>
                  {topics.length ? 'Select a topic' : 'No topics available'}
                </option>
                {topics.map((topic, index) => (
                  <option className={questionData.primaryLanguage == 'fganh' || questionData.primaryLanguage == 'हिंदी' ? 'hinditext':''} key={index} value={topic}>
                    <span className={questionData.primaryLanguage == 'fganh' || questionData.primaryLanguage == 'हिंदी' ? 'hinditext':''}>{topic}</span>
                  </option>
                ))}
              </Input>
            </FormGroup>
          </div>

          {/* Rest of the Form */}
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '20px',
            }}
          >
            {questionData.questionLanguages.map((language) => (
              <div key={language}>
                <FormGroup>
                  <Label style={{ color: '#fff' }}>Question (<span className={questionData.primaryLanguage == 'fganh' || questionData.primaryLanguage == 'हिंदी' ? 'hinditext':''}>{language}</span>)*</Label>
                  <div style={{display:'flex',alignItems:'center'}}>
                  <Input
                    type='text'
                    className={questionData.primaryLanguage == 'fganh' || questionData.primaryLanguage == 'हिंदी' ? 'hinditext':''}
                    value={questionData[language]?.question || ''}
                    onChange={(e) => handleInputChange(e, language, 'question')}
                    placeholder={`Enter the question in ${language}`}
                    required
                    style={inputStyle}
                  />
                  <FunctionsIcon onClick={()=>{
                      setMathExpEdit({ language, for: 'question', text: questionData[language]?.question || '' })
                      setIsOpenEditMathExpKeyBoard(true);
                      console.log('isQuiz Exicuted')}}/>
                    </div>
                </FormGroup>

                <FormGroup>
                  <Label style={{ color: '#fff' }}>Options (<span className={questionData.primaryLanguage == 'fganh' || questionData.primaryLanguage == 'हिंदी' ? 'hinditext':''}>{language}</span>)*</Label>
                  {questionData[language]?.options?.map((option, index) => (
                    <div
                      key={index}
                      style={{ display: 'flex', marginBottom: '10px' }}
                    >
                      <Input
                        type='text'
                        className={questionData.primaryLanguage == 'fganh' || questionData.primaryLanguage == 'हिंदी' ? 'hinditext':''}
                        value={option}
                        onChange={(e) =>
                          handleArrayChange(e, language, 'options', index)
                        }
                        placeholder={`Option ${index + 1}`}
                        style={inputStyle}
                      />
                        <FunctionsIcon onClick={()=>{
                          console.log('optionIs Exicuted');
                          setMathExpEdit({ language, for: 'options', text: option, index });
                          setIsOpenEditMathExpKeyBoard(true);
                        }}/>
                      <Delete
                        aria-label={`Delete option ${index + 1}`}
                        style={{
                          color: 'red',
                          cursor: 'pointer',
                          marginLeft: '10px',
                        }}
                        onClick={() => removeField(language, 'options', index)}
                      />
                    </div>
                  ))}
                  <Button
                    color='info'
                    onClick={() => addNewField(language, 'options')}
                    style={{ marginBottom: '10px' }}
                  >
                    Add Option
                  </Button>
                </FormGroup>

                <FormGroup>
                  <Label style={{ color: '#fff' }}>
                    Correct Option (<span className={language == 'fganh' ? 'hinditext' : ''}>{language}</span>)*
                  </Label>
                  <Input
                    type='text'
                    value={questionData[language]?.correctOption || ''}
                    onChange={(e) =>
                      handleInputChange(e, language, 'correctOption')
                    }
                    placeholder={`Enter the correct option in ${language}`}
                    required
                    style={inputStyle}
                  />
                </FormGroup>

                <FormGroup>
                  <Label style={{ color: '#fff' }}>
                    Correct Option Explanation (<span className={language == 'fganh' ? 'hinditext' : ''}>{language}</span>)*
                  </Label>
                  <Input
                    type='text'
                    className={language == 'fganh' ? 'hinditext' : ''}
                    value={questionData[language]?.correctOptionExplanation || ''}
                    onChange={(e) =>
                      handleInputChange(e, language, 'correctOptionExplanation')
                    }
                    placeholder={`Enter the correct option Explanation in ${language == "fganh" ? "हिंदी" : language}`}
                    required
                    style={inputStyle}
                  />
                </FormGroup>
              </div>
            ))}

            <FormGroup>
              <Label style={{ color: '#fff' }}>Difficulty (1-5)*</Label>
              <Input
                type='number'
                name='difficulty'
                value={questionData.difficulty}
                onChange={handleInputChange}
                min={1}
                max={5}
                required
                style={inputStyle}
              />
            </FormGroup>
          </div>
        </form>
      </div>

      <div style={{ backgroundColor: 'rgb(39, 41, 61)', display: 'flex', justifyContent: 'end', alignItems: 'center', gap: '12px', padding: '12px' }}>
        <Button color='info' onClick={handleSubmit}>Update Question</Button>
        <Button color='secondary' onClick={() => { navigate(-1) }}>Cancel</Button>
      </div>
      <EditQuestionMathModal isOpen={IsOpenEditMathExpKeyBoard} onClose={() => (setIsOpenEditMathExpKeyBoard(false))} mathExpEdit={mathExpEdit} handleInputChange={handleInputChange} handleArrayChange={handleArrayChange}/>
    </div>
  ); 
};

export default EditQuestionPage;
